import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import { useSettings } from "../../hooks/useSettings";
import { useSearchParams } from "react-router-dom";
import GiftIcon from "@mui/icons-material/CardGiftcard";
import HelpIcon from "@mui/icons-material/HelpOutline";

const GuestPage: React.FC = () => {
   const [searchParams] = useSearchParams();
  const shop_domain = searchParams.get("shop_domain");
  const { settings, getSetting, loading } = useSettings();

   const primaryColor = getSetting('primary_color', process.env.REACT_APP_PRIMARY_COLOR || '#1E3A8A');
  const hoverColor = getSetting('widget_hover_color', process.env.REACT_APP_PRIMARY_COLOR_HOVER || '#2563EB');
  const storeName = getSetting('app_name', process.env.REACT_APP_STORE_NAME || 'Store');
   const siteurl = getSetting('site_url', '');

  const onClickSignin = () => {
    localStorage.setItem("shop_domain", shop_domain || '');
    const shopifyLoginUrl = `/account/login`;
    window.parent.postMessage({ action: 'redirectsignin', url: shopifyLoginUrl }, '*');
  };

  const onClickJoin = () => {
    localStorage.setItem("shop_domain", shop_domain || '');
    const joinUrl = `/account/register`;
    window.parent.postMessage({ action: 'redirectjoin', url: joinUrl }, '*');
  };

  
 
  if (loading && !settings) {
    return (
      <div className="flex flex-col h-[100vh] w-screen overflow-x-hidden items-center justify-center">
        <div>Loading settings...</div>
      </div>
    );
  }

  return (
    <div 
      className="flex flex-col h-[100vh] w-screen overflow-x-hidden"  
      style={{ '--primary-color': primaryColor } as React.CSSProperties}
    >
      <div className="flex flex-col flex-grow">
        <div className="h-100 bg-gradient-to-b from-[var(--primary-color)] via-[var(--primary-color)] to-white">
          <div className="w-screen relative top-10 flex justify-between items-center px-6 py-8 ">
           <div className="flex items-center">
                            <GiftIcon className="text-white mr-2" />
                            <span className="text-white">Rewards</span>
                        </div>
                        <div className="flex items-center">
                            {/* <HelpIcon className="text-white" />
                            <span className="text-white mr-2">FAQ's</span> */}
                        </div>
          </div>
          <div className="w-screen relative top-10">
            <p className="text-white text-[16px] ml-6">Welcome to</p>
            <p className="text-white text-[20px] ml-6 font-semibold">{storeName}</p>
            <Card
              className="p-4 shadow-lg m-4 flex justify-center items-center"
              sx={{
                borderRadius: "10px",
                backgroundColor: "#ffffff",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="flex flex-col space-y-2 text-center">
                <div className="flex text-black font-bold justify-center items-center">
                  <p>Become a member</p>
                </div>
                <div className="flex flex-1 flex-col justify-center items-center text-greyCustom text-[14px]">
                  <p>
                    With more ways to unlock exciting perks, this is your all access pass to
                    exclusive rewards.
                  </p>
                </div>
                <div className="flex flex-1 flex-col justify-center items-center text-[14px] w-full">
                  <Button
                    onClick={onClickJoin}
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: primaryColor,
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: hoverColor, 
                      },
                      paddingY: '8px',
                      paddingX: '24px',
                      borderRadius: '8px',
                      marginTop: '12px',
                      marginBottom: '12px',
                    }}
                  >
                    Join now
                  </Button>
                </div>
                <div className="flex flex-1 flex-col justify-center items-center text-[14px]">
                  <p>
                    Already have an account?&nbsp;
                    <Button 
                      onClick={onClickSignin} 
                      style={{ color: primaryColor }}
                    >
                      Sign in
                    </Button>
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestPage;